import WindowIpcRouter, { type WindowIpcRouterType } from '@shared/ipc/routers/WindowIpc.router'
import type { ViewWindowRequest } from '@shared/sidepanel/view-window-route'

class WindowIpcRenderer extends WindowIpcRouter implements WindowIpcRouterType {
  async openSettingsWindow(route?: string): Promise<void> {
    return this.exec('openSettingsWindow', route)
  }

  async openViewWindow(request: ViewWindowRequest): Promise<void> {
    return this.exec('openViewWindow', request)
  }

  async openOnboardingWindow(): Promise<void> {
    return this.exec('openOnboardingWindow')
  }

  async onboardingRequiredByServer(): Promise<void> {
    return this.exec('onboardingRequiredByServer')
  }

  async openPermissionsSetup(): Promise<boolean> {
    return this.exec('openPermissionsSetup')
  }

  async adoptExistingOnboarding(): Promise<boolean> {
    return this.exec('adoptExistingOnboarding')
  }
}

export default new WindowIpcRenderer()
